import type ItemModel from 'bcl/models/item';

import activeItems from './activeItems.json';

const deactivatedItems = [
  {
    name: 'old Pott Rum 40%',
    product_group: 1,
    deposits: [0, 0],
    price: 0,
    sizes: [6, 1000, 20],
  },
  {
    name: 'Coca Cola PET',
    product_group: 1,
    deposits: [0, 0],
    price: 0,
    orders: [5],
    location: [0, 0, 0, 0],
    sizes: [6, 1000, 20],
  },
  {
    name: 'Brunner Tomatensaft',
    product_group: 1,
    deposits: [0, 0],
    price: 0,
    orders: [5],
    sizes: [6, 1000, 20],
  },
  {
    name: 'Brunner Maracujasaft',
    product_group: 1,
    deposits: [0, 0],
    price: 0,
    location: [0, 0, 0, 0],
    sizes: [6, 1000, 20],
  },
  {
    name: 'Brunner Orangensaft',
    product_group: 1,
    deposits: [0, 0],
    price: 0,
    sizes: [6, 1000, 20],
  },
  {
    name: 'Berliner Pilsner 0,5l',
    product_group: 1,
    deposits: [0, 0],
    price: 0,
    sizes: [6, 1000, 20],
  },
  {
    name: 'Berliner Pilsner 100 l',
    product_group: 1,
    deposits: [0, 0],
    price: 0,
    sizes: [6, 1000, 20],
  },
];

export async function createExampleItems(store: any) {
  const existing = store.peekAll('item');
  if (existing.length > 0) {
    return false;
  }
  const activeModels = [];
  for (let i = 0; i < activeItems.length; i++) {
    const item = activeItems[i];
    activeModels.push(
      await store
        .createRecord('item', {
          name: item?.name,
          active: true,
          product_group: store.peekRecord('product-group', item?.product_group),
          deposit_container: item?.deposits[0],
          deposit_single: item?.deposits[1],
          gross_price: item?.price,
          container_size: item?.sizes[0],
          single_size: item?.sizes[1],
          serving_size: item?.sizes[2],
          company: store.peekRecord('company', 1),
        })
        .save()
    );
  }

  const deactivatedModels = deactivatedItems.map(async (item) => {
    return store
      .createRecord('item', {
        name: item?.name,
        active: false,
        product_group: store.peekRecord('product-group', item?.product_group),
        deposit_container: item?.deposits[0],
        deposit_single: item?.deposits[1],
        gross_price: item?.price,
        container_size: item?.sizes[0],
        single_size: item?.sizes[1],
        serving_size: item?.sizes[2],
        company: store.peekRecord('company', 1),
      })
      .save();
  });
  let models = activeModels.concat(deactivatedModels);
  console.log(models[0]);
  models = await Promise.all(models);
  console.log(models[0]);
  await createOrderEntries(store, activeItems, activeModels);
  await createLocationEntries(store, activeItems, activeModels);
}
async function createOrderEntries(
  store: any,
  items: any[],
  models: ItemModel[]
) {
  const existing = store.peekAll('order-entry');
  if (existing.length > 0) {
    return false;
  }
  const suppliers = [
    store
      .peekAll('supplier')
      .filter((item) => item.name === 'Getränke Preiss Münchhagen GmbH')[0],
    store.peekAll('supplier').filter((item) => item.name === 'Lehmann')[0],
  ];
  const orders = [...store.peekAll('order')];

  orders.sort((a, b) => a.delivery_date - b.delivery_date);
  const ordEntries = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const model = models[i];

    const supItem = store.createRecord('supplier-item', {
      supplier: suppliers[0],
      item: model,
      price: item.kaufen,
      articlenr: item.nr || 'AN-' + Math.floor(Math.random() * 100000),
      standard_order: item.supplier == 1 ? 5 : 0,
    });
    await supItem.save();
    const supItem2 = store.createRecord('supplier-item', {
      supplier: suppliers[1],
      item: model,
      price: item.kaufen,
      articlenr: item.nr || 'AN-' + Math.floor(Math.random() * 100000),
      standard_order: item.supplier == 2 ? 5 : 0,
    });
    await supItem2.save();

    const preuss = item.supplier == 1;
    const mySupItem = preuss ? supItem : supItem2;
    const myOrders = preuss ? [orders[0], orders[2]] : [orders[1]];
    // create items in order
    for (let j = 0; j < myOrders.length; j++) {
      const ord = myOrders[j];
      if (!ord) {
        continue;
      }
      const ordEntry = store.createRecord('order-entry', {
        order: ord,
        supplier_item: mySupItem,
        amount: Math.floor(Math.random() * 10) + 1,
        position: i,
      });
      await ordEntry.save();
      ordEntries.push(ordEntry);
    }
  }
}
async function createLocationEntries(
  store: any,
  items: any[],
  models: ItemModel[]
) {
  console.log('creating location entries');
  const existing = store.peekAll('location-item');
  if (existing.length > 0) {
    return false;
  }
  const lager = store
    .peekAll('location')
    .filter((item) => item.name === 'Lager')[0];
  const tresen = store
    .peekAll('location')
    .filter((item) => item.name === 'Tresen')[0];
  const locations = [tresen, lager];

  // location: [5, 6, 14, 20],
  const locationItems = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const model = models[i];
    if (!item.location) {
      continue;
    }
    for (let j = 0; j < item.location.length; j += 2) {
      const ist = item.location[j];
      const soll = item.location[j + 1];
      // if (!soll) {
      //   continue;
      // }
      const locationItem = store.createRecord('location-item', {
        location: locations[j / 2],
        item: model,
        proposal_amount: soll,
      });
      console.log(locationItem);
      locationItems.push(await locationItem.save());
    }
  }
  return Promise.all(locationItems);
}
